// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zjI64cMwQjw6tktV {
  padding: 24px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.DWDeGfWeV8UXcZSg {
  width: 352px;
  height: 100px;
  border-radius: 8px;
  opacity: 1;
  background: #f3f6fa;
  display: flex;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;
}
.p_a6uCBXMFEoddaP {
  width: 48px;
  height: 48px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: contain;
  margin-top: 26px;
  margin-right: 16px;
}
.AVqDkUrP9DU_rG1V {
  margin-top: 16px;
}
.hMSyvCnIdvU0KqeY {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  line-height: 18px;
}
.GTKBo5YL86k5u7GC {
  color: #999999;
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  margin-top: 8px;
}
.dCp3gT24GrQskZSV {
  color: #999999;
  font-size: 12px;
  line-height: 17px;
  margin-top: 8px;
}
.lgbC61z8zYz_apSN {
  vertical-align: middle;
  display: inline-block;
  margin-right: 8px;
}
.QA1mtdSqaswpOcJL {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.QA1mtdSqaswpOcJL:hover {
  color: #0095fc;
}
.EzkFd35hDDoRlB1g {
  flex: 1;
  text-align: right;
}
.UjogE5ZHF8Y1VawP {
  width: 24px;
  height: 24px;
  line-height: 24px;
  position: absolute;
  right: 8px;
  top: 8px;
  text-align: center;
  cursor: pointer;
}
.RHChOwMMBCobfC3c {
  position: absolute;
  right: 16px;
  bottom: 16px;
  color: #ff6200;
  font-size: 12px;
  line-height: 17px;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/CardList/index.modules.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,iBAAA;EACA,8BAAA;AACF;AACA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AACF;AACA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;EACA,gCAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACA;EACE,gBAAA;AACF;AACA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AACF;AACA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AACF;AACA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AACF;AACA;EACE,sBAAA;EACA,qBAAA;EACA,iBAAA;AACF;AAEA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;AAAF;AACE;EACE,cAAA;AACJ;AAEA;EACE,OAAA;EACA,iBAAA;AAAF;AAEA;EACE,WAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AADF;AAGA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AADF","sourcesContent":[".CardList {\n  padding: 24px;\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n}\n.cardItem {\n  width: 352px;\n  height: 100px;\n  border-radius: 8px;\n  opacity: 1;\n  background: #f3f6fa;\n  display: flex;\n  padding: 0 16px;\n  box-sizing: border-box;\n  position: relative;\n}\n.cardBg {\n  width: 48px;\n  height: 48px;\n  background-repeat: no-repeat;\n  background-position: left center;\n  background-size: contain;\n  margin-top: 26px;\n  margin-right: 16px;\n}\n.cardInfo {\n  margin-top: 16px;\n}\n.cardTit {\n  font-size: 14px;\n  font-weight: bold;\n  color: #333;\n  line-height: 18px;\n}\n.version {\n  color: #999999;\n  font-size: 12px;\n  font-weight: normal;\n  line-height: 16px;\n  margin-top: 8px;\n}\n.cardTime {\n  color: #999999;\n  font-size: 12px;\n  line-height: 17px;\n  margin-top: 8px;\n}\n.versionText {\n  vertical-align: middle;\n  display: inline-block;\n  margin-right: 8px;\n}\n\n.icon {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  vertical-align: middle;\n  &:hover {\n    color: #0095fc;\n  }\n}\n.rSide {\n  flex: 1;\n  text-align: right;\n}\n.iconWrapper {\n  width: 24px;\n  height: 24px;\n  // margin: 8px 8px 0 0;\n  line-height: 24px;\n  position: absolute;\n  right: 8px;\n  top: 8px;\n  text-align: center;\n  cursor: pointer;\n}\n.status {\n  position: absolute;\n  right: 16px;\n  bottom: 16px;\n  color: #ff6200;\n  font-size: 12px;\n  line-height: 17px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CardList": `zjI64cMwQjw6tktV`,
	"cardItem": `DWDeGfWeV8UXcZSg`,
	"cardBg": `p_a6uCBXMFEoddaP`,
	"cardInfo": `AVqDkUrP9DU_rG1V`,
	"cardTit": `hMSyvCnIdvU0KqeY`,
	"version": `GTKBo5YL86k5u7GC`,
	"cardTime": `dCp3gT24GrQskZSV`,
	"versionText": `lgbC61z8zYz_apSN`,
	"icon": `QA1mtdSqaswpOcJL`,
	"rSide": `EzkFd35hDDoRlB1g`,
	"iconWrapper": `UjogE5ZHF8Y1VawP`,
	"status": `RHChOwMMBCobfC3c`
};
export default ___CSS_LOADER_EXPORT___;
